import i18n from "src/utils/i18n";

const PK_STATUS_NEW = "0";
const PK_STATUS_SOLD = "10";

export interface ReservationCheckbox {
  id: string;
  label: string;
  value: string;
  checked: boolean;
}

export const buyOptions: () => ReservationCheckbox[] = () => [
  {
    id: "reservation_type",
    label: i18n.t("reservationList.search.reservation_type.reserve"),
    value: "reserve",
    checked: false,
  },
  {
    id: "reservation_type",
    label: i18n.t("reservationList.search.reservation_type.resale"),
    value: "resale",
    checked: false,
  },
];
export const sellOptions: () => ReservationCheckbox[] = () => [
  {
    id: "status",
    label: i18n.t("reservationList.search.product_status.new"),
    value: PK_STATUS_NEW,
    checked: false,
  },
  {
    id: "status",
    label: i18n.t("reservationList.search.product_status.sold"),
    value: PK_STATUS_SOLD,
    checked: false,
  },
];
